<template>
  <div id="content" :class="currentView">
    <PageEditorAlert
      v-if="isTabletOrMobile"
      :text="$options.deviceAlertMessage"
      size="small"
      icon="info-circle"
      variant="info"
    />

    <div id="device">
      <component v-for="container in containers()" :key="container.id" :is="container.type" :id="container.id" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Section from '@/components/page-editor/Section'
import Tabs from '@/components/page-editor/Tabs'
import HeroSparkBanner from '@/components/page-editor/HeroSparkBanner'
import PageEditorAlert from '@/components/PageEditorAlert'

export default {
  components: { HeroSparkBanner, Section, Tabs, PageEditorAlert },
  computed: {
    ...mapState('landing', ['currentView']),
    ...mapGetters('landing', ['containers']),
    isTabletOrMobile() {
      return this.currentView !== 'lg'
    },
  },
  deviceAlertMessage:
    '<strong>Atenção:</strong> Essa é apenas uma visualização em outros dispositivos. Qualquer alteração irá refletir em todos os dispositivos.',
}
</script>

<style lang="scss">
#content {
  z-index: 1;
  grid-area: content;
  background: #e0e0e0;
  float: left;
  transition: all 0.2s;
  height: calc(100vh - 64px);
  overflow-y: auto;
  width: calc(100vw - 360px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  #device {
    height: auto;

    transition: all 0.2s;
    overflow-y: auto;

    display: flex;
    flex-wrap: wrap;
  }

  &.sm > #device {
    transition: all 0.2s;
    width: 375px;
  }
  &.md > #device {
    transition: all 0.2s;
    width: 600px;
  }
  &.lg > #device {
    transition: all 0.2s;
    width: 100%;
    @media screen and (min-width: 1400px) {
      width: 100%;
    }
  }
}
</style>
